import {useForm, FormProvider} from 'react-hook-form'
import {useHistory} from 'react-router-dom'

import {SlotManagementConfigurationDetails} from './components/SlotManagementConfigurationDetails'
import {useSlotManagementConfigsCreateMutation} from './hooks/useSlotManagementConfigsMutation'
import {SlotManagementConfig} from './types/SlotManagementConfig'

type SlotManagementCreateConfig = Omit<SlotManagementConfig, 'id'>

const emptyFormState: SlotManagementCreateConfig = {
  countryCode: '',
  businessLine: '',
  orgUnitId: '',
  dispatchGroup: '',
  plantNumber: '',
  autoConfirmLeadTime: undefined
}

export const SlotManagementConfigurationCreate = () => {
  const history = useHistory()
  const slotManagementConfigsMutation = useSlotManagementConfigsCreateMutation()

  const methods = useForm<SlotManagementCreateConfig>({
    defaultValues: emptyFormState,
    mode: 'onChange'
  })

  const handleCreateButtonClick = async (data: SlotManagementCreateConfig) => {
    try {
      await slotManagementConfigsMutation.mutateAsync(data)
      // Only navigate back on success
      history.goBack()
    } catch (error) {
      // Error is handled by mutation hook with toast notifications
      // Don't navigate back - keep form open
    }
  }

  return (
    <FormProvider {...methods}>
      <SlotManagementConfigurationDetails
        mode="create"
        onSaveButtonClick={methods.handleSubmit(handleCreateButtonClick)}
        isSubmitting={slotManagementConfigsMutation.isLoading}
      />
    </FormProvider>
  )
}
